import { BUILD_VERSION, ENVIRONMENT } from '../../constants';

export const API_REQUEST_MESSAGE = 'API_REQUEST_MESSAGE';

const buildVersionParts = BUILD_VERSION.split('.').map((part) =>
  parseInt(part, 10),
);

export const BUILD_VERSION_HEADER_NAME = 'x-build-version';
export const BUILD_VERSION_MAJOR = buildVersionParts[0];
export const BUILD_VERSION_MINOR = buildVersionParts[1];
// export const BUILD_VERSION_PATCH = buildVersionParts[2];
export const DEFAULT_AXIOS_RETRIES = ENVIRONMENT.AXIOS_RETRIES;
export const SERVER_ID_HEADER_NAME = 'x-snap-logid';
export const XSRF_COOKIE_NAME = 'xsrfToken';
export const XSRF_HEADER_NAME = 'X-Xsrf-Token';
